module.exports = __webpack_public_path__ + "img/30daysofuichallenge.78b49b00.svg";